<!-- 现场技术问题报告书 -->
<template>
	<el-dialog :visible.sync="visible" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false" class="data-dialog" width="1200px">
		<span slot="title" class="dialog-title">
			<img src="@/assets/images/close.png" alt="" @click="visible = false" />
		</span>
		<button class="el-button down-btn menu-btn el-button--primary" @click="handlePdf()">下载</button>
		<div class="mrt-content" ref="pdfcontent">
			<h1>附表8 现场技术问题报告书(FPR)</h1>
			<h3>（推荐电脑编辑后打印）</h3>
			<h3 class="mb5">报告书编号：{{ form.serialNumber }}</h3>
			<table>
				<tr>
					<th colspan="2">机 型</th>
					<th>机 号</th>
					<th>复印计数器</th>
					<th>制版计数器</th>
					<th>安装日期</th>
					<th>问题发生日期</th>
				</tr>
				<tr class="tr-height-60">
					<td colspan="2">{{ form.repairDeviceName }}</td>
					<td>{{ form.repairDeviceNumber }}</td>
					<td>
						黑白：{{ form.partsClaimWarranty.blackWhiteCounter }}
						<br />
						彩色：{{ form.partsClaimWarranty.colorCounter }}
					</td>
					<td>{{ form.partsClaimWarranty.plateCounter }}</td>
					<td>{{ form.partsClaimWarranty.installDate.replaceAll("-", "/") }}</td>
					<td>{{ form.partsClaimWarranty.faultDate.replaceAll("-", "/") }}</td>
				</tr>
				<tr>
					<th colspan="3">用户公司名</th>
					<th>用户公司印</th>
					<th colspan="3">用户地址</th>
				</tr>
				<tr>
					<td rowspan="3" colspan="3">{{ form.partsClaimCustomer.userName }}</td>
					<td rowspan="3"></td>
					<td colspan="3">{{ form.partsClaimCustomer.addressDetail }}</td>
				</tr>
				<tr>
					<td>用户联系人</td>
					<td>用户电话</td>
					<td>用户传真</td>
				</tr>
				<tr>
					<td>{{ form.partsClaimCustomer.contactName }}</td>
					<td>{{ form.partsClaimCustomer.userPhone }}</td>
					<td></td>
				</tr>
			</table>
			<table>
				<tr>
					<th class="th-title-left">主题：</th>
					<th colspan="4"></th>
					<th class="th-title-left" colspan="2">报告日:{{ form.submitTime.substring(0, 10).replaceAll("-", "/") }}</th>
					<th class="th-title-left" colspan="2">受理日:{{ createName.substring(0, 10).replaceAll("-", "/") }}</th>
				</tr>
				<tr>
					<td rowspan="2" colspan="6" class="th-title-left_top">
						现 象：请填写你看到的实际现象）
						<br />
						<p class="td-text-center">{{ form.partsClaimWarranty.failureSymptom }}</p>
					</td>
					<td colspan="3" class="th-title-left">
						<template>
							<p style="font-weight: bold">发生频率：</p>
							<p>一直 [ ] 经常 [ ] 不定 [ ]</p>
						</template>
					</td>
				</tr>
				<tr>
					<td colspan="3" class="th-title-left">
						<template>
							<p style="font-weight: bold">现状描述：</p>
							<p>停机 [ ] 观察中 [ ]</p>
						</template>
					</td>
				</tr>
				<tr class="tr-height-80">
					<td colspan="9" class="th-title-left_top">
						<template>
							<span>原 因：（请填写你认为可能的原因）</span>
							<p class="td-text-center">{{ form.partsClaimWarranty.failureReason }}</p>
						</template>
					</td>
				</tr>
				<tr class="tr-height-80">
					<td colspan="9" class="th-title-left_top">
						<template>
							<span>措 施：（请填写你亲自实施过的措施）</span>
							<p class="td-text-center">{{ form.partsClaimWarranty.failureAction }}</p>
						</template>
					</td>
				</tr>
				<tr>
					<th colspan="7" class="th-title-left">结 果：（请填写你实施上述措施后的结果）</th>
					<th colspan="2">维修公司的要求：</th>
				</tr>
				<tr>
					<td rowspan="3" colspan="7">
						<p class="td-text-center">{{ form.partsClaimWarranty.failureResult }}</p>
					</td>
					<td colspan="2" class="th-title-left">现场支援 [ ]</td>
				</tr>
				<tr>
					<td colspan="2" class="th-title-left">零件索赔 [ ✓ ]</td>
				</tr>
				<tr>
					<td colspan="2" class="th-title-left">先行赔付 [{{ form.partsClaimWarranty.isPrepaid == 1 ? " ✓" : "" }} ]</td>
				</tr>
				<tr>
					<td colspan="9">更换的零件</td>
				</tr>
				<tr>
					<td colspan="2">RCN填写</td>
					<td colspan="7">经销商填写后RCN确认</td>
				</tr>
				<tr>
					<td colspan="2">受理结果</td>
					<td colspan="3">零件号码</td>
					<td colspan="3">零件名称</td>
					<td colspan="1">数量</td>
				</tr>
				<tr v-for="(item, i) in partsDetailList" :key="i">
					<td colspan="2">{{ item.auditMsg }}</td>
					<td colspan="3">{{ item.partsNumber }}</td>
					<td colspan="3">{{ item.partsName }}</td>
					<td colspan="1">{{ item.partsAmount }}</td>
				</tr>
			</table>
			<table>
				<tr>
					<th colspan="1">维修公司名称：</th>
					<th colspan="4">{{ form.applyOrgName }}</th>
					<th>维修公司印</th>
					<th>区域代理印</th>
				</tr>
				<tr>
					<td colspan="1">维修公司地址：</td>
					<td colspan="4"></td>
					<td rowspan="3">{{ form.createUsrCompany }}</td>
					<td rowspan="3">{{ form.auditOrgType == 1 && form.auditOrgName ? form.auditOrgName : "" }}</td>
				</tr>
				<tr>
					<td colspan="1">报告者名</td>
					<td>负责人签名</td>
					<td>联系电话</td>
					<td>联系传真</td>
					<td>邮政编码</td>
				</tr>
				<tr>
					<td colspan="1">{{ form.createUsrNamePhone ? form.createUsrNamePhone.split("/")[0] : "" }}</td>
					<td></td>
					<td>{{ form.createUsrNamePhone ? form.createUsrNamePhone.split("/")[1] : "" }}</td>
					<td></td>
					<td></td>
				</tr>
			</table>
			<table>
				<tr class="tr-height-100">
					<template>
						<div class="opinion">
							<span>技术支援课处理意见：</span>
							<span class="opinion-date">完成日：{{ audit1.createTime.substring(0, 10).replaceAll("-", "/") }}</span>
						</div>
						<p class="td-text-center">{{ audit1.remark }}</p>
					</template>
				</tr>
			</table>
		</div>
	</el-dialog>
</template>
<script>
import JsPDF from "jspdf";
import html2Canvas from "html2canvas";

export default {
	data() {
		return {
			visible: false,
			form: {
				createUsrNamePhone: "",
				createUsrCompany: "",
				submitTime: "",
				serialNumber: "",
				repairType: "1", // 索赔的类型 1、保修期内机器零件故障 2、理光单独订购零件 3、商品（耗材故障）
				applyOrgType: "", // 申请方信息-机构类型 1、网络店 2、特约维修店 3、代理商 4、分部
				applyOrgId: "", // 申请方信息 对应的机构id
				auditOrgType: "", // 资料审核方-机构类型 1、其它进货代理商 2、理光
				auditOrgId: "", // 资料审核方 对应的机构id
				applyOrgName: "", // 申请方信息-机构名称
				repairModelId: "", // 机型及开发名 一级
				repairDeviceId: "", // 机型及开发名 二级
				repairDeviceName: "",
				repairDeviceNumber: "", // 机号
				isSubmit: 0, // 是否提交 0否(表示暂存)  1是(提交索赔)
				repairDevices: [],
				//基本信息
				partsClaimWarranty: {
					isPrepaid: "",
					installDate: "", // 安装日期
					invoiceDate: "", // 发票日期
					faultDate: "", // 故障日期
					blackWhiteCounter: "", // 计数器（黑白）
					colorCounter: "", // 计数器（彩色）
					plateCounter: "", // 制版计数器
					failureSymptom: "", // 故障现象
					failureReason: "", // 故障原因
					failureAction: "", // 故障处理措施
					failureResult: "", // 故障处理结果
					claimAddress: "", // 索赔件收货地址
					additionalNotes: "", // 补充说明栏
					warrantyCardInSystem: "", // 保修卡是否在系统内 0否 1是
					cardInSystemFileIdList: [], // 保修卡附件列表
					purchaseLeaseFileIdList: [], //购机发票或租赁合同上传文件的id
					purchaseLeaseRemark: "", // 购机发票或租赁合同-备注
					smcFileIdList: [], //SMC（系统参数报告）上传文件的id
					smcRemark: "", // SMC（系统参数报告）-备注
					failureSampleFileIdList: [], //故障样张或照片上传文件的id
					failureSampleRemark: "", // 故障样张或照片-备注
					faultyPartsFileIdList: [], // 故障零件或耗材（色粉）上传文件的id
				},
				// 客户信息
				partsClaimCustomer: {
					// 省市县三级，提交时删除
					allAddress: [],
					userName: "", // 用户名
					contactName: "", // 联系人姓名
					userPhone: "", // 用户电话
					province: "", // 省
					city: "", // 市
					district: "", // 区县
					addressDetail: "", // 详细地址
				},
				// 机器零件信息
				partsDetailList: [],
			},
			partsDetailList: [],
			// 技术支援课处理意见
			audit1: {
				createTime: "",
				createName: "",
				remark: "",
			},
			// 受理日
			createName: "",
			auditStatusMsg: {
				"-1": "拒绝",
				1: "同意并安排发货",
				"-2": "拒绝发货",
				2: "无货等待",
				3: "索赔发货",
			},
		};
	},
	methods: {
		init(data) {
			this.visible = true;
			this.$nextTick(() => {
				setTimeout(() => {
					this.form = data.form;
					console.log(this.form);
					let oldNum = data.partsDetailLists ? data.partsDetailLists.length : data.form.partsDetailList.length;
					let fillNum = 4 - oldNum;
					let fillArray = data.partsDetailLists
						? JSON.parse(JSON.stringify(data.partsDetailLists))
						: JSON.parse(JSON.stringify(data.form.partsDetailList));
					if (fillNum > 0) {
						for (let index = 0; index < fillNum; index++) {
							fillArray.push({
								partsName: "",
								partsNumber: "",
								partsAmount: "",
							});
						}
					}
					this.partsDetailList = fillArray;
					for (const element of this.partsDetailList) {
						if (element.partsName != "") {
							if (element.currentAudit) {
								element.auditMsg = this.auditStatusMsg[element.currentAudit.auditStatus];
							} else {
								element.partsResult == "1" ? (element.auditMsg = "拒绝") : (element.auditMsg = "同意并安排发货");
							}
						}
					}
					this.form.createUsrCompany = data.form.currentAudit.createUsrCompany;
					if (this.form.hisAudit) {
						for (const element of this.form.hisAudit) {
							// 技术支援课处理意见
							if ([3, 5].includes(element.auditStatus)) {
								this.audit1 = element;
							}
							if ([4].includes(element.auditStatus)) {
								this.audit1 = element;
							}
						}
						this.createName = this.form.hisAudit.length > 1 ? this.form.hisAudit[1].createTime : "";
					}
					data.auditRemarks ? (this.audit1.remark = data.auditRemarks) : "";
				}, 50);
			});
		},
		// pdf下载
		handlePdf() {
			const title = "附表8 现场技术问题报告书(FPR)_" + new Date().getTime();
			const opts = {
				scale: window.devicePixelRatio * 3,
				dpi: window.devicePixelRatio * 4,
				allowTaint: true,
				useCORS: true,
			};
			let that = this;
			html2Canvas(this.$refs.pdfcontent, opts).then(function (canvas) {
				let imgWidth = 595.28;
				let imgHeight = 860;
				let pageData = canvas.toDataURL("image/jpeg", 1.0);
				let PDF = new JsPDF("", "pt", "a4");
				PDF.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
				PDF.save(title + ".pdf");
				that.visible = false;
			});
		},
	},
};
</script>
<style lang="scss" scoped>
.data-dialog /deep/ .el-dialog {
	border-radius: 10px !important;
}

.data-dialog /deep/ .el-dialog__body {
	padding: 0 20px !important;
}

.data-dialog .dialog-title {
	display: block;
	text-align: center;

	span {
		color: #222;
		font-weight: 600;
		font-size: 20px;
	}

	img {
		width: 28px;
		float: right;
		cursor: pointer;
	}
}

.mrt-content {
	padding: 80px 60px;
	background-color: white;
	color: black;

	h1 {
		font-size: 28px;
		font-weight: normal;
		text-align: left;
		margin-bottom: 15px;
		color: black;
	}

	h3 {
		font-size: 16px;
		font-weight: normal;
		text-align: right;
		color: black;
	}

	table {
		width: 100%;
		border-collapse: collapse;
		border: 3px solid black;
		font-size: 16px;
		font-weight: normal;
		color: black;
		margin-bottom: 15px;
		table-layout: fixed;
	}

	th,
	td {
		border: 1.1px solid black;
	}

	th,
	td {
		font-weight: normal;
		padding: 6px;
		background-color: white;
		text-align: center;
		white-space: normal;
		word-wrap: break-word;
	}

	tr {
		height: 40px;
	}

	td {
		width: 150px;
	}

	.tr-height-60 {
		height: 60px;
	}

	.tr-height-80 {
		height: 80px;
	}

	.tr-height-100 {
		height: 100px;
	}

	.th-title-left {
		text-align: left;
	}

	.th-title-left_top {
		text-align: left;
		vertical-align: top;
	}

	.td-text-center {
		text-align: center;
		vertical-align: center;
	}

	.th-inst {
		text-align: left;
		white-space: normal;
		word-wrap: break-word;
	}

	.opinion {
		display: flex;
		justify-content: space-between;

		.opinion-date {
			border: 1px solid black;
			height: 30px;
			width: 180px;
			line-height: 30px;
			text-align: center;
		}
	}
}
</style>
